import {
  DISPLAY_DIVISION_IN_FORM_FOR_TOURNAMENT,
  SET_EVENT_SELECTED_FOR_TOURNAMENT,
  SET_VIRTUAL_EVENT_SELECTED_FOR_TOURNAMENT,
  DISPLAY_NEW_DIVISION_FOR_TOURNAMENT,
  CANCEL_DIVISION_FORM_FOR_TOURNAMENT,
  HIGHTLIGHT_SELECTED_EVENT_FOR_TOURNAMENT_DIVISIONS,
  HIGHLIGHT_SELECTED_VIRTUAL_EVENT_FOR_TOURNAMENT_DIVISIONS,
  DISPLAY_EVENTS_FOR_TOURNAMENT_DIVISIONS,
  DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_DIVISIONS,
  DISPLAY_DIVISION_FOR_TOURNAMENT_EVENT,
  SET_DIVISION_DISPLAY_DEFAULT
} from './constants';

const initialState = {
  eventIdSelected: null,
  virtualEventIdSelected: null,
  selectedEventName: '',
  events: [],
  virtualEvents: [],
  divisions: []
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case DISPLAY_DIVISION_IN_FORM_FOR_TOURNAMENT: {
      state.divisions.forEach(entry => {
        entry.editing = entry.id === payload;
      });
      return {
        ...state,
        ...{divisions: [...state.divisions.filter(entry => entry.id)]} // return only items with information (not empty ones)
      };
    }
    case SET_EVENT_SELECTED_FOR_TOURNAMENT:{
      const event = state.events.find(item => {
        return item.id === payload;
      });
      const eventName = event ? event.name : '';
      const displayDefault = event ? event.displayDefault : false;
      const averageBased = event ? event.averageBased : false;
      const ageBased = event ? event.ageBased : false;
      const genderBased = event ? event.genderBased : false;

      return {
        ...state,
        ...{
          eventIdSelected: payload,
          selectedEventName: eventName,
          displayDefault: displayDefault,
          selectedEventAverageBased: averageBased,
          selectedEventAgeBased: ageBased,
          selectedEventGenderBased: genderBased
        }
      };
    }
    case SET_VIRTUAL_EVENT_SELECTED_FOR_TOURNAMENT:{
      const event = state.virtualEvents.find(item => {
        return item.id === payload;
      });
      const eventName = event ? event.name : '';
      const displayDefault = event ? event.displayDefault : false;
      const averageBased = event ? event.averageBased : false;
      const ageBased = event ? event.ageBased : false;
      const genderBased = event ? event.genderBased : false;
      
      return {
        ...state,
        ...{
          virtualEventIdSelected: payload,
          selectedEventName: eventName,
          displayDefault: displayDefault,
          selectedEventAverageBased: averageBased,
          selectedEventAgeBased: ageBased,
          selectedEventGenderBased: genderBased
        }
      };
    }
    case DISPLAY_NEW_DIVISION_FOR_TOURNAMENT: {
      return {
        ...state,
        displayDefault: true,
        ...{
          divisions: [
            {editing: true, name: '[Create Division]'},
            ...state.divisions
          ]
        }
      };
    }
    case CANCEL_DIVISION_FORM_FOR_TOURNAMENT: {
      state.divisions.forEach(item => {
        item.editing = false;
      });
      return {
        ...state,
        ...{divisions: [...state.divisions.filter(item => item.id)]} // return only items with information (not empty ones)
      };
    }
    case HIGHTLIGHT_SELECTED_EVENT_FOR_TOURNAMENT_DIVISIONS:
      state.events.forEach(item => {
        item.highlight = item.id === payload;
      });
      return {
        ...state,
        ...{events: [...state.events]}
      };
    case HIGHLIGHT_SELECTED_VIRTUAL_EVENT_FOR_TOURNAMENT_DIVISIONS:
      state.virtualEvents.forEach(item => {
        item.highlight = item.id === payload;
      });
      return {
        ...state,
        ...{virtualEvents: [...state.virtualEvents]}
      };
    case DISPLAY_EVENTS_FOR_TOURNAMENT_DIVISIONS:
      return {
        ...state,
        ...{events: payload}
      };
    case DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_DIVISIONS:
      return {
        ...state,
        ...{virtualEvents: payload}
      };
    case DISPLAY_DIVISION_FOR_TOURNAMENT_EVENT:
      return {
        ...state,
        ...{divisions: payload}
      };
    case SET_DIVISION_DISPLAY_DEFAULT:
      state.displayDefault = !state.divisions.find(elem => {return elem.id == payload;}).isDefault;
      return {
        ...state
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/tournament/divisions/reducer.js